package com.milta.core.localization.translations.pl

import com.milta.core.localization.UnlocatedDeliveryStrings

internal val UnlocatedDelivery = UnlocatedDeliveryStrings(
    warningTitleSingular = "1 adres niezlokalizowany",
    warningTitlePlural = "Niezlokalizowane adresy: %d",
    warningMessage = "Tych dostaw nie udało się umieścić na mapie. Popraw ich adres lub kontynuuj: zostaną dodane na końcu trasy.",
    fixAction = "Popraw",
    continueWithoutAction = "Kontynuuj bez nich",
    unplacedStopsSingular = "1 przystanek nieumieszczony, na końcu trasy",
    unplacedStopsPlural = "Przystanki nieumieszczone: %d, na końcu trasy",
    fixAddressAction = "Popraw adres",
    unlocatedBadge = "Niezlokalizowany",
)
